export default __webpack_public_path__ + "static/media/background-image-truck-mountains.2b7aa596.jpg";